import { AnimationComponent, Box, Grid2, Show, Tab, Tabs } from "components";
import DashboardLayout from "layouts/DashboardLayout";
import Partner from "Pages/CompanyOrganisation/Partner";
import BranchAdmins from "Pages/Organisations/BranchAdmins";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { AccountType } from "utils/common";

const CompanyOrganisationMenu = () => {
  const dispatch = useAppDispatch();

  const { organisationTab } = useAppSelector((state) => state?.app?.tab);
  const userInfo = useAppSelector((state) => state?.user?.userData);

  const tabs = [
    {
      label: "Admin",
      component: <BranchAdmins path={"/employees/"} />,
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Partner",
      component: <Partner />,
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
  ];

  return (
    <DashboardLayout title="Organisation">
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              sx={{
                "& .MuiTabs-flexContainer": {
                  backgroundColor: "var(--white)",
                },
              }}
              onChange={(e, val) => {
                dispatch(TAB({ tabKey: "organisationTab", tabValue: val }));
              }}
              value={organisationTab}
            >
              {tabs
                ?.filter((tab) =>
                  tab?.accountType?.includes(userInfo?.accountType),
                )
                ?.map((tab, index) => (
                  <Tab key={index} label={tab.label} disableRipple />
                ))}
            </Tabs>
          </Box>
        </Grid2>
        <Grid2 size={12}>
          {tabs.map((tab, index) => (
            <Show.When key={index} isTrue={organisationTab === index}>
              <AnimationComponent>{tab.component}</AnimationComponent>
            </Show.When>
          ))}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default CompanyOrganisationMenu;
